export default {"src":"/_next/static/media/grid-icon.c3931b5c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};